export default "__VITE_ASSET__C1ZA_aqd__"